import z from 'zod';
import { timestampSchema } from './commonSchemas.js';
/**
 * Schema per CategoryDefRow
 * Rappresenta il tipo di riga della tabella categories
 * @db_table categories
 */
export const categoryDefRowSchema = z.object({
    /** ID della categoria */
    id: z.number().int().positive("Il numero deve essere>0").describe('type:number,editable:false,label:ID'),
    /** Nome/titolo della categoria */
    title: z.string().min(1, "Il titolo della categoria è obbligatorio").max(255).describe('label:Titolo'),
    /** Descrizione dettagliata della categoria (opzionale) */
    description: z.string().nullable().optional().describe('type:textarea,label:Descrizione'),
    /** Data di creazione */
    created_at: timestampSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    /** Data di ultimo aggiornamento */
    updated_at: timestampSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
/**
 * Schema per inserimento/aggiornamento categoria (senza ID e timestamp)
 */
export const categoryDefRowSchemaNoId = categoryDefRowSchema.omit({
    id: true,
    created_at: true,
    updated_at: true
});
//# sourceMappingURL=categoryDefSchema.js.map